import {Component, inject} from '@angular/core'
import {MatIconButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {RouterLink} from '@angular/router'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {LogoComponent, ToggleButtonComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {RoleHelper} from '../../services/role-helper'
import {CREDIT_ROLE, CUSTOMER_SUPPORT_ROLE, INTERNAL_SUPPORT_ROLE, WATCH_ROLE} from '../../services/types'

@Component({
  selector: 'spb-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    RouterLink,
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatMenuItem,
    LogoComponent,
    MatIconButton,
    ToggleButtonComponent
  ]
})
export class HeaderComponent {
  public configService = inject(ConfigService)

  public roleHelper = inject(RoleHelper)
  protected readonly WATCH_ROLE = WATCH_ROLE
  protected readonly CUSTOMER_SUPPORT_ROLE = CUSTOMER_SUPPORT_ROLE
  protected readonly INTERNAL_SUPPORT_ROLE = INTERNAL_SUPPORT_ROLE
  protected readonly CREDIT_ROLE = CREDIT_ROLE
}
